var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
// Generated by `npm run icon`, don't modify this file
import React from 'react';
import Base from './_base';
const ChevronUp = props => {
    const { className = null } = props, other = __rest(props, ["className"]);
    return (<Base viewBox="0 0 16 16" className={`cuk2-icon-chevron_up ${className}`} {...other}>
      <g>
        <path d="M12.808 11.602l.384-.32a.5.5 0 00.064-.705L8 4.27l-5.256 6.307a.5.5 0 00.064.704l.384.32a.5.5 0 00.704-.063L8 6.615l4.104 4.923a.5.5 0 00.704.064z" fillRule="evenodd"/>
      </g>
    </Base>);
};
export default ChevronUp;
